import { styled, grayMedium } from "@styles";
import { IProps } from "./types";

export const Wrapper = styled.span<IProps>`
  ${({status}) => status  == "success" 
  ? `background-color: green;`
  : `background-color: #ddd;`}
  content: "";
  display: inline-block;
  height: .5rem;
  width: .5rem;
  border-radius: 1rem;
  margin-bottom: 1px;
  margin-right: .5rem;
`;

export const Span = styled.span``;